import R from 'ramda'
import { createLocalStorageStateHook } from 'use-local-storage-state'

const useSelectionBaseHook = createLocalStorageStateHook(
  'elliiFlashcardSelection',
  []
)

export default function useSelection() {
  const [selection, setSelection] = useSelectionBaseHook()

  const addToSelection = flashcards => {
    if (!Array.isArray(flashcards))
      throw new Error(
        'addToSelection requires an array of at least 1 flashcard'
      )

    // 1. Destructure required properties for selection state
    // 2. Initialize the selection with a default userTitle
    const selectionData = flashcards.map(
      ({ id, image, imageGrayscale, thumbnail, title }) => ({
        id,
        image,
        imageGrayscale,
        thumbnail,
        title,
        userTitle: title,
      })
    )

    setSelection(current =>
      // 1. Filter out any already selected flashcards from the flashcards that were passed in
      //    (required for selecting whole category, if FC from category was individually selected previously)
      // 2. Prepend the filtered flashcards array to the existing selection array
      // 3. Flatten the result and set it as the new selection
      R.flatten(R.prepend(R.without(current, selectionData), current))
    )
  }

  const removeFromSelection = flashcardIds => {
    if (!Array.isArray(flashcardIds))
      throw new Error(
        'removeFromSelection requires an array of at least 1 flashcard ID'
      )

    return setSelection(current =>
      R.without(
        flashcardIds.map(id => R.find(R.propEq('id', id), current)),
        current
      )
    )
  }

  const clearSelection = () => setSelection([])

  const editSelectionUserTitle = ({ id, value }) =>
    setSelection(current =>
      R.adjust(
        current.findIndex(fc => fc.id === id),
        R.assoc('userTitle', value),
        current
      )
    )

  return {
    selection,
    setSelection, // only used for applying a new order to the selection, not meant for general use!
    clearSelection,
    addToSelection,
    removeFromSelection,
    editSelectionUserTitle,
  }
}
